module.exports = __webpack_public_path__ + "img/bowser-min.1a6420ac.png";